import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';

export function MessageList({ messages, streaming, suggestedPrompts, onPromptClick, messagesEndRef }) {
  if (messages.length === 0) {
    return (
      <div className="text-center py-8">
        <Sparkles className="w-12 h-12 text-primary mx-auto mb-4 opacity-50" />
        <p className="text-text-muted mb-4">Ask me anything about your business</p>
        <div className="flex flex-wrap gap-2 justify-center">
          {suggestedPrompts.map((prompt, idx) => (
            <button
              key={`prompt-${idx}-${prompt.substring(0, 10)}`}
              onClick={() => onPromptClick(prompt)}
              className="px-4 py-2 text-sm bg-surface border border-border rounded-lg hover:bg-surface-hover transition-colors text-foreground"
              data-testid={`suggested-prompt-${idx}`}
            >
              {prompt}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      {messages.map((msg, idx) => (
        <div
          key={`message-${idx}-${msg.role}-${msg.content.substring(0, 20)}`}
          className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
        >
          <div
            className={`max-w-[85%] rounded-lg p-4 ${
              msg.role === 'user'
                ? 'bg-primary text-white'
                : 'bg-surface border border-border text-foreground'
            }`}
            data-testid={`chat-message-${idx}`}
          >
            <p className="text-sm whitespace-pre-wrap leading-relaxed">{msg.content}</p>
          </div>
        </div>
      ))}
      {streaming && messages[messages.length - 1]?.content === '' && (
        <div className="flex justify-start">
          <div className="max-w-[85%] rounded-lg p-4 bg-surface border border-border">
            <Loader2 className="w-4 h-4 animate-spin text-primary" />
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </>
  );
}
